export default {
  data() {
    return {
      search: '',
      selectedGroupsIds: [],
    };
  },
  methods: {
    onToggleGroup(id) {
      this.selectedGroupsIds = this.selectedGroupsIds.includes(id)
        ? this.selectedGroupsIds.filter(item => item !== id)
        : [...this.selectedGroupsIds, id];
    },
    onToggleAll() {
      this.selectedGroupsIds = this.everySelected
        ? this.selectedGroupsIds.filter(id => !this.filteredGroupsIds.includes(id))
        : this.filteredGroups.map(group => group.id);
    },
  },
  computed: {
    allGroups() {
      return JSON.parse(this.groups);
    },
    filteredGroups() {
      return Array.isArray(this.allGroups)
        ? this.allGroups.filter(group => group.name.toLowerCase().includes(this.search.toLowerCase()))
        : [];
    },
    filteredGroupsIds() {
      return this.filteredGroups.map(group => group.id);
    },
    everySelected() {
      return this.filteredGroups.every(group => this.selectedGroupsIds.includes(group.id));
    },
    stringifyIds() {
      return JSON.stringify(this.selectedGroupsIds);
    },
  },
};
